// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getSource, getSourceId, getTimestamp, getUpdate, getObjectName, getObjectId
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isSystemUpdate } from 'conversations-message-history/crm-object-lifecycle-update/operators/isSystemUpdate';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getPipelineStage } from 'conversations-message-history/crm-object-lifecycle-update/operators/ticketUpdateMetadataGetters';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import FullSenderName from '../senders/components/FullSenderName';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-async-data/async-data/operators/getters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getDateString } from 'conversations-message-history/util/labelDateUtils';
import CrmTicketLink from './CrmTicketLink';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmTicketAssociationUpdateMessage = ({
  message,
  senders,
  userId,
  portalId,
  onTicketLinkClick = () => {}
}) => {
  const senderId = getSourceId(message);
  const senderType = getSource(message);
  const timestamp = getTimestamp(message);
  const momentTimestamp = I18n.moment(timestamp);
  const messageOptions = {
    dateString: getDateString(momentTimestamp),
    pipelineStage: /*#__PURE__*/_jsx("b", {
      children: getPipelineStage(getUpdate(message))
    }),
    ticketName: /*#__PURE__*/_jsx(CrmTicketLink, {
      objectId: getObjectId(message),
      portalId: portalId,
      onClick: onTicketLinkClick,
      objectName: /*#__PURE__*/_jsx("b", {
        children: getObjectName(message)
      })
    })
  };
  if (senderId === userId) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.associationUpdate.currentAgent",
      options: messageOptions
    });
  }
  if (isSystemUpdate(message)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.associationUpdate.system",
      options: messageOptions
    });
  }
  const asyncSender = findSender(senderId, senderType, senders);
  const isLoading = isSenderLoading(asyncSender);
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200,
      "data-test-id": 'skeleton-text'
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.associationUpdate.agent",
    options: Object.assign({
      agent: /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FullSenderName, {
          sender: getData(asyncSender)
        })
      })
    }, messageOptions)
  });
};
CrmTicketAssociationUpdateMessage.displayName = 'CrmTicketAssociationUpdateMessage';
CrmTicketAssociationUpdateMessage.propTypes = {
  message: RecordPropType('CrmObjectLifecycleUpdate').isRequired,
  onTicketLinkClick: PropTypes.func,
  portalId: PropTypes.number.isRequired,
  senders: SenderMap.isRequired,
  userId: PropTypes.number.isRequired
};
export default CrmTicketAssociationUpdateMessage;